import * as THREE from 'three';

export default class DraggableObject extends THREE.Object3D {

  constructor(options) {
    super();
    this._options = options;
    if (options.mesh) {
      this.children.push(options.mesh);
    }
  }

  get options() {
    return this._options;
  }
  get mesh() {
    return this._options.mesh;
  }
  get htmlObject() {
    return this._options.htmlObject;
  }
  get startPosition() {
    return this._startPosition;
  }
  get endPosition() {
    return this._endPosition;
  }
  get startPositionHTML() {
    return this._startPositionHTML;
  }

  onDragStart() {
    this._startPosition = this.mesh.position.clone();
    if (this.htmlObject) {
      this._startPositionHTML = this.options.htmlObject.position.clone();
      // at the of DragEnd a render is triggered and new elements are created for which the onHoverEnter is not called
      // make sure to disable the html before dragging the control
      if (this.options.hideHTMLObjectOnHover && this.options.htmlObject.domElement.style.display !== 'none') {
        this.options.htmlObject.domElement.style.display = 'none';
      }
    }
    if (this._options.onDragStart)
      this.options.onDragStart(this);
  }
  onDragEnd() {
    this._endPosition = this.mesh.position.clone();
    if (this._options.onDragEnd)
      this.options.onDragEnd(this);
  }
  onDrag() {
    if (this.options.onDrag)
      this.options.onDrag(this);
  }
  onHoverEnter() {
    if (this.options.hideHTMLObjectOnHover && this.htmlObject) {
      this.options.htmlObject.domElement.style.display = 'none';
    }

    if (this._options.onHoverEnter)
      this.options.onHoverEnter(this);
  }
  onHoverExit() {
    if (this.options.hideHTMLObjectOnHover && this.htmlObject) {
      this.htmlObject.domElement.style.display = "";
    }

    if (this._options.onHoverExit)
      this.options.onHoverExit(this);
  }

  getMeshUuid() {
    return this.options.mesh.uuid;
  }
  
}



// WEBPACK FOOTER //
// ./src/object-view/objects/draggable-object.js